import React from 'react';
import QueryBuilder from './components/querybuilder/querybuilder.jsx';
import '../../../../tokens/sass/base-style/index.scss';
import './App.scss';

const AppDiagrams = (props) => {
  const apiBuffer = props;

  return (
    <div>
      <div className="App">
        <QueryBuilder
          apiEndpoint={apiBuffer.apiurl}
          vistype={apiBuffer.vistype}
          context={apiBuffer.context}
          epoch={apiBuffer.epoch}
        />
      </div>
    </div>
  );
};

export default AppDiagrams;
